<template>
  <circle
    class="donut-svg-fill"
    :cx="centerX"
    :cy="centerY"
    :r="radius"
    :stroke-width="strokeWidth"
    :style="{
      stroke: color,
      'stroke-dasharray': dashArray,
      'stroke-dashoffset': dashOffset,
      'transition-duration': transitionDuration + 'ms',
    }"
  />
</template>

<script>
/**
 * A fill circle for use in donut charts.
 * The value is represented by the border using stroke-dasharray and stroke-offset to position the colored piece.
 *
 * Note: This should always be used inside of an `<svg>` element.
 */
export default {
  name: 'DonutSvgFill',
  props: {
    centerX: {
      type: Number,
      required: true,
    },
    centerY: {
      type: Number,
      required: true,
    },
    radius: {
      type: Number,
      required: true,
    },
    strokeWidth: {
      type: Number,
      required: true,
    },
    dashArray: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    dashOffset: {
      type: Number,
    },
    transitionDuration: {
      type: Number,
      default: 500,
    },
  },
}
</script>

<style lang="scss" scoped>
.donut-svg-fill {
  fill: transparent;
  transform: rotate(-90deg);
  transform-origin: center;
  transition: stroke-dasharray var(--transition-medium) ease-out,
    stroke-dashoffset var(--transition-medium) ease-out;
}
</style>
